// Ported from CDK

import {
    AmericanExpressLogo,
    ApplePayLogo,
    DinersClubLogo,
    DiscoverLogo,
    GooglePayLogo,
    JCBLogo,
    MastercardLogo,
    VisaLogo
} from "@logos";

type PaymentMethodVendorKey = `visa` | `apple` | `master` | `amex` | `jcb` | `google` | `discover` | `diner`;

export interface PaymentMethodVendor {
    key: PaymentMethodVendorKey;
    name: string;
    color: string;
    icon: React.ComponentType;
}

const PAYMENT_METHOD_VENDORS: Record<PaymentMethodVendorKey, PaymentMethodVendor> = {
    visa: {
        key: `visa`,
        name: `Visa`,
        color: `neutral`,
        icon: VisaLogo
    },
    apple: {
        key: `apple`,
        name: `Apple Pay`,
        color: `neutral`,
        icon: ApplePayLogo
    },
    master: {
        key: `master`,
        name: `Mastercard`,
        color: `neutral`,
        icon: MastercardLogo
    },
    amex: {
        key: `amex`,
        name: `American Express`,
        color: `#1F72CD`,
        icon: AmericanExpressLogo
    },
    jcb: {
        key: `jcb`,
        name: `JCB`,
        color: `neutral`,
        icon: JCBLogo
    },
    google: {
        key: `google`,
        name: `Google Pay`,
        color: `neutral`,
        icon: GooglePayLogo
    },
    discover: {
        key: `discover`,
        name: `Discover`,
        color: `neutral`,
        icon: DiscoverLogo
    },
    diner: {
        key: `diner`,
        name: `Diner's Club`,
        color: `neutral`,
        icon: DinersClubLogo
    }
};

export function getPaymentMethodVendor(sourceName?: string | null): PaymentMethodVendor | null {
    if (!sourceName) return null;

    const patterns: Array<{ regex: RegExp; key: PaymentMethodVendorKey }> = [
        { regex: /visa/i, key: `visa` },
        { regex: /apple/i, key: `apple` },
        { regex: /master/i, key: `master` },
        { regex: /(amex|american)/i, key: `amex` },
        { regex: /jcb/i, key: `jcb` },
        { regex: /google/i, key: `google` },
        { regex: /discover/i, key: `discover` },
        { regex: /diner/i, key: `diner` }
    ];

    for (const pattern of patterns) {
        if (pattern.regex.test(sourceName)) {
            return PAYMENT_METHOD_VENDORS[pattern.key];
        }
    }

    return null;
}
